import { ComponentProps } from 'react';
import isEqual from 'react-fast-compare';

import ItemShelf from '@/components/ItemShelf/ItemShelf';
import { ItemShelfCarousel } from '@/components/ItemShelfCarousel/ItemShelfCarousel';
import { useAppSelector } from '@/redux/hooks';
import { getItemSummaries } from '@/redux/modules/item/summary/itemSummary.selectors';
import { orderByCatalogSaleStartAscending } from '@/redux/modules/sorting';
import { getHasLoadedUpcomingIds, getUpcomingItemIds } from '@/redux/modules/upcoming/items/upcomingItems.selectors';
import { ItemSummary } from '@/types/item/ItemSummary';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

type Props = {
    className?: string;
    shouldUseHomePageRedesign?: boolean;
    testid?: string;
};

export const ComingUpCarousel = ({ className, shouldUseHomePageRedesign = false, testid }: Props) => {
    const formatMessage = useAppFormatMessage();
    const upcomingItemIds = useAppSelector(getUpcomingItemIds);
    const items = useAppSelector((state) => getItemSummaries(state, upcomingItemIds), isEqual);
    const sortedItems = (orderByCatalogSaleStartAscending(items) || []) as ItemSummary[];
    const itemIds = sortedItems.slice(0, 12).map(({ itemId }) => itemId);
    const upcomingItemsLoaded = useAppSelector(getHasLoadedUpcomingIds);

    if (!itemIds.length && upcomingItemsLoaded) {
        return null;
    }

    const shelfProps: ComponentProps<typeof ItemShelf> = {
        allowBidding: true,
        className,
        identifier: 'comingUp',
        itemIds,
        showBidStatus: true,
        showPagination: false,
        testid,
        title: String(formatMessage(['coming_up_title'])),
    };

    if (shouldUseHomePageRedesign) {
        return <ItemShelfCarousel {...shelfProps} />;
    }

    return <ItemShelf {...shelfProps} />;
};
